export const getParsedRouteParam = param => {
  return param
    .replace(/-/g, ' ')
    .replace(/_/g, "'")
    .trim();
};

export const encodeRouteParam = param => {
  return param
    .replace(/\s/g, '-')
    .replace(/'/g, '_')
    .trim()
    .toLowerCase();
};



// WEBPACK FOOTER //
// ./src/utility/parseRouteParams.js